import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsentComponent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');

    // 1) Her sayfa açıldığında kesin denied sinyali gönder
    (window as any).gtag?.('consent', 'update', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });

    window.dataLayer.push({
      event: 'consent_denied_initial',
    });

    // 2) Eğer user daha önce accepted ise hemen granted gönder
    if (consentGiven === 'accepted') {
      (window as any).gtag?.('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });

      window.dataLayer.push({
        event: 'cookieConsentAccepted',
      });
    }

    // 3) Eğer reddedilmişse reddedilmiş sinyali gönder
    if (consentGiven === 'rejected') {
      window.dataLayer.push({
        event: 'cookieConsentRejected',
      });
    }

    // 4) Banner’ı kontrollü göster
    if (!consentGiven || consentGiven === 'rejected') {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);

    (window as any).gtag?.('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });

    window.dataLayer.push({
      event: 'cookieConsentAccepted',
    });
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowConsent(false);

    (window as any).gtag?.('consent', 'update', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });

    window.dataLayer.push({
      event: 'cookieConsentRejected',
    });
  };

  if (!showConsent) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        borderTop: '2px solid #e74c3c',
        padding: '16px 24px',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px',
      }}
    >
      <div style={{ flex: 1, minWidth: '280px' }}>
        <p
          style={{
            margin: 0,
            fontSize: '14px',
            color: '#333',
            lineHeight: '1.5',
          }}
        >
          Bu web sitesi deneyiminizi geliştirmek için çerezleri kullanmaktadır.
          YouTube videoları ve diğer üçüncü taraf içerikler için gerekli
          çerezler kullanılabilir. Sitemizi kullanmaya devam ederek, gizlilik
          politikamızı kabul etmiş olursunuz.
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '12px',
          flexShrink: 0,
          flexWrap: 'wrap',
        }}
      >
        <button
          onClick={handleReject}
          style={{
            padding: '8px 16px',
            border: '1px solid #e74c3c',
            backgroundColor: 'transparent',
            color: '#e74c3c',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#e74c3c';
            e.currentTarget.style.color = '#fff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#e74c3c';
          }}
        >
          Reddet
        </button>
        <button
          onClick={handleAccept}
          style={{
            padding: '8px 16px',
            border: 'none',
            backgroundColor: '#e74c3c',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#c0392b';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#e74c3c';
          }}
        >
          Kabul Et
        </button>
      </div>
    </div>
  );
};

export default CookieConsentComponent;
